<template>
  <v-container :class="className">
    <v-layout row>
      <v-flex xs12 class="text-xs-center">
        <h1>Лучший сервис для гостей</h1>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md3 class="plus-box text-xs-center">
        <v-icon x-large class="icons">local_taxi</v-icon>
        <div class="plus-h1">Бесплатный трансфер</div>
        <div>При бронировании более 2х часов, трансфер бесплатно за счет заведения!</div>
      </v-flex>
      <v-flex xs12 md3 class="plus-box text-xs-center">
        <v-icon x-large class="icons">card_travel</v-icon>
        <div class="plus-h1">Документы для командировочных</div>
        <div>Если вы находитесь в командировке, мы оформим вам все необходимые документы и чеки.</div>
      </v-flex>
      <v-flex xs12 md3 class="plus-box text-xs-center">
        <v-icon x-large class="icons">wifi</v-icon>
        <div class="plus-h1">Бесплатный Wi-Fi</div>
        <div>Бесплатный Wi-Fi для гостей во всех номерах и саунах.</div>
      </v-flex>
      <v-flex xs12 md3 class="plus-box text-xs-center">
        <v-icon x-large class="icons">restaurant</v-icon>
        <div class="plus-h1">Полноценная кухня</div>
        <div>У нас работает полноценная кухня для гостей! Вы можете заказать любое блюдо из нашего меню и наш повар приготовит для вас в течении 30 минут!</div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: [
    'className'
  ]
}
</script>

<style scoped>
.plus-box {
  padding: 40px 10px 0px 10px;
}

.plus-img {
  width: 120px;
  height: 120px;
  background-size: cover;
  background-repeat: no-repeat;
  margin: 0px auto;
}

.plus-h1 {
  font-size: 22px;
  margin: 20px 0px;
  color: green;
}

.icons {
  color: green;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {
  .plus-h1 {
    font-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/screens/malina/Plus.vue